"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReadingPrompt = void 0;
var react_1 = __importDefault(require("react"));
var core_1 = require("../../../../shared/core");
var copy_1 = require("../../copy");
var utils_1 = require("../../utils");
var ReadingPrompt = function (_a) {
    var fuel = _a.fuel, lastActualElecRead = _a.lastActualElecRead, lastActualGasRead = _a.lastActualGasRead;
    var InfoNotification = (0, core_1.useComponents)().InfoNotification;
    var Copy = (0, core_1.useCopy)(copy_1.defaultOptions).Copy;
    var showBanner = (lastActualElecRead && (0, utils_1.readIsAboveThreshold)(lastActualElecRead)) ||
        (lastActualGasRead && (0, utils_1.readIsAboveThreshold)(lastActualGasRead));
    return (react_1.default.createElement(InfoNotification, { id: "send-reading", "data-testid": "reading-prompt" },
        (fuel === 'both' || fuel === 'electricity') &&
            lastActualElecRead &&
            (0, utils_1.readIsAboveThreshold)(lastActualElecRead) && (react_1.default.createElement(Copy, { copyKey: "lastElecReading", props: { lastActualElecRead: lastActualElecRead } })),
        (fuel === 'both' || fuel === 'gas') &&
            lastActualGasRead &&
            (0, utils_1.readIsAboveThreshold)(lastActualGasRead) && (react_1.default.createElement(Copy, { copyKey: "lastGasReading", props: { lastActualGasRead: lastActualGasRead } })),
        fuel === 'both' ? (react_1.default.createElement(Copy, { copyKey: "genericReadingPrompt", props: { fuel: fuel, showBanner: showBanner } })) : (react_1.default.createElement(Copy, { copyKey: "readingPrompt", props: { fuel: fuel, showBanner: showBanner } }))));
};
exports.ReadingPrompt = ReadingPrompt;
